(() => {
  const data = JSON.parse(document.getElementById('AnAmouageMotionData')?.textContent || '{}');
  const controllers = new Map();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const image = (src, cls) => {
    const el = document.createElement('img'); el.className = cls; el.alt = ''; el.setAttribute('aria-hidden','true'); el.draggable = false; el.decoding = 'async'; el.dataset.src = src; return el;
  };
  const init = scope => scope.querySelectorAll('[data-amouage-motion]').forEach(stage => {
    if (controllers.has(stage)) return;
    const p = data[stage.dataset.amouageMotion]; if (!p) return;
    stage.classList.add('an-motion-stage'); stage.closest('.an-card-visual').classList.add('an-motion-visual');
    stage.dataset.shape = p.ratio >= .62 ? 'wide' : 'narrow'; stage.style.setProperty('--ground-width',(p.ratio*66.4*.9)+'%');
    const wide = p.ratio >= .62, four = p.notes.length === 4;
    const angles = wide ? (four ? [-26,26,-14,14] : [-26,26,-10]) : (four ? [-28,28,-13,14] : [-28,29,10]);
    const heights = wide ? (four ? [64,64,72,72] : [66,64,75]) : (four ? [62,59,67,66] : [63,61,68]);
    const roots = wide ? (four ? [43,57,47,53] : [42,58,53]) : p.notes.map((_,i) => i%2 ? 51 : 49);
    const ground = document.createElement('span'); ground.className = 'an-motion-ground'; ground.setAttribute('aria-hidden','true'); stage.append(ground);
    p.notes.forEach((note,i) => {
      const el = document.createElement('span'); el.className = 'an-motion-sprig'; el.setAttribute('aria-hidden','true');
      el.style.setProperty('--angle',angles[i]+'deg'); el.style.setProperty('--height',heights[i]+'%'); el.style.setProperty('--root',roots[i]+'%'); el.style.setProperty('--delay',i*55+'ms');
      el.append(image(note,'an-motion-material')); stage.append(el);
    });
    stage.append(image(p.bottle,'an-motion-bottle'));
    let ready = false, loading, hovering = false, holding = false, keyHold = false, start, timer, navigateOnRelease = false, suppressUntil = 0;
    const update = () => { stage.classList.toggle('an-motion-active',ready && (hovering || holding || keyHold)); };
    const load = () => {
      if (loading) return loading;
      loading = Promise.all([...stage.querySelectorAll('img[data-src]')].map(el => new Promise(resolve => {
        el.onload = () => resolve(true); el.onerror = () => resolve(false); el.src = el.dataset.src;
        if (el.complete) resolve(el.naturalWidth > 0);
      }))).then(results => { ready = results.every(Boolean); stage.dataset.motionReady = String(ready); update(); });
      return loading;
    };
    const clear = () => { clearTimeout(timer); timer = null; start = null; navigateOnRelease = false; holding = false; keyHold = false; update(); };
    stage.addEventListener('pointerenter',event => { if(event.pointerType === 'mouse'){hovering = true; load(); update();} });
    stage.addEventListener('pointerleave',event => { if(event.pointerType === 'mouse'){hovering = false; update();} });
    stage.addEventListener('pointerdown',event => {
      if(event.pointerType === 'mouse' || !event.isPrimary) return;
      if(holding && !start){ clear(); navigateOnRelease = true; suppressUntil = 0; return; }
      clear(); load(); start = {x:event.clientX,y:event.clientY};
      stage.setPointerCapture(event.pointerId);
      holding = true; update();
    });
    stage.addEventListener('pointermove',event => { if(start && Math.hypot(event.clientX-start.x,event.clientY-start.y)>12){if(holding)suppressUntil=Date.now()+500;clear();} });
    stage.addEventListener('pointerup',() => {
      if(navigateOnRelease){ navigateOnRelease = false; return; }
      if(!start) return;
      start = null;
      if(holding){ suppressUntil = Date.now()+500; timer = setTimeout(clear,1600); }
    });
    stage.addEventListener('pointercancel',clear); stage.addEventListener('lostpointercapture',() => {if(start)clear();});
    stage.addEventListener('click',event => { if(Date.now()<suppressUntil){event.preventDefault();event.stopImmediatePropagation();} },true);
    stage.addEventListener('contextmenu',event => event.preventDefault());
    stage.addEventListener('dragstart',event => event.preventDefault());
    stage.addEventListener('keydown',event => { if(event.code==='Space'){event.preventDefault();keyHold=true;load();update();} });
    stage.addEventListener('keyup',event => { if(event.code==='Space'){event.preventDefault();keyHold=false;update();} });
    stage.addEventListener('blur',clear);
    const reset = () => { hovering = false; clear(); };
    controllers.set(stage,{reset,load}); observer.observe(stage);
  });
  const observer = new IntersectionObserver(entries => entries.forEach(entry => { if(entry.isIntersecting){controllers.get(entry.target)?.load();observer.unobserve(entry.target);} }),{rootMargin:'150px'});
  const reset = () => controllers.forEach((controller,stage) => {controller.reset();if(!stage.isConnected){observer.unobserve(stage);controllers.delete(stage);} });
  window.addEventListener('blur',reset); document.addEventListener('visibilitychange',() => {if(document.hidden)reset();});
  motion.addEventListener('change',reset); document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',reset);
  init(document);
})();
